export const textVideoBulletsYTPlayerInit = () => {
  const videoId = document.getElementById('textVideoBulletsYTPlayer').getAttribute('data-video-id');
  let videoPlayerWidth;
  let videoPlayerHeight;
  let player;

  if ( typeof window.YT === 'undefined' ) {
    const scriptTag = document.createElement( 'script' );

    scriptTag.src = 'https://www.youtube.com/iframe_api';
    document.getElementsByTagName( 'head' )[0].appendChild( scriptTag );
  }

  window.addEventListener('load', () => {
    player = new YT.Player('textVideoBulletsYTPlayer', {
      height: '1440',
      width: '2560',
      videoId: videoId,
      events: {
        'onReady': onPlayerReady
      },
      playerVars: {
        autoplay: 1,
        controls: 0,
        mute: 1,
        iv_load_policy: 3,
        loop: 1,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
        showinfo: 0,
        playlist: videoId
      },
      suggestedQuality: 'hd1080'
    });

    function resizeToCover() {
      const videoPlayer = document.getElementById('textVideoBulletsYTPlayer');
      const videoWrapper = document.querySelector('.blockTextVideoBullets__video');
      let scaleHorizontal = videoWrapper.offsetWidth / videoPlayerWidth;
      let scaleVertical = videoWrapper.offsetHeight / videoPlayerHeight;
      let scale = scaleHorizontal > scaleVertical ? scaleHorizontal : scaleVertical;

      videoPlayer.style.width = `${(scale * videoPlayerWidth)}px`;
      videoPlayer.style.height = `${(scale * videoPlayerHeight)}px`;
    };
    
    function onPlayerReady(event) {
      videoPlayerWidth = parseInt(document.getElementById('textVideoBulletsYTPlayer').getAttribute('width'));
      videoPlayerHeight = parseInt(document.getElementById('textVideoBulletsYTPlayer').getAttribute('height'));

      resizeToCover();
      window.addEventListener('resize', resizeToCover);
      event.target.playVideo();
    }
  });
}